import {useQuery} from 'react-query';
import {getStoreOrderDetails} from './getStoreOrderDetails';
import {IOrderResponse} from './types';

interface UseGetStoreOrderDetailsOptions {
  orderGuid?: string;
  onSuccess?: (data: IOrderResponse) => void;
}

const useGetStoreOrderDetails = ({
  orderGuid,
  onSuccess,
}: UseGetStoreOrderDetailsOptions) => {
  const {data, isLoading, refetch, isError, error} = useQuery<IOrderResponse>(
    ['get-store-order-details', orderGuid],
    () => getStoreOrderDetails({orderGuid}),
    {
      enabled: Boolean(orderGuid),
      onSuccess,
    },
  );

  return {
    data,
    isLoading,
    refetch,
    isError,
    error,
  };
};

export default useGetStoreOrderDetails;
